module.exports = __webpack_public_path__ + "static/media/user-control.31138705.svg";